import { LayoutHOC } from 'base/ui/layout/layout';
import { createHistoryReceiveDetail } from './detail';

export const createHistoryReceiveDetailPage = (layoutHOC: LayoutHOC) => {
  return layoutHOC(createHistoryReceiveDetail());
};
